import { render } from "./HumanizedPlain.vue?vue&type=template&id=32c1c1b8&scoped=true"
import script from "./HumanizedPlain.vue?vue&type=script&lang=js"
export * from "./HumanizedPlain.vue?vue&type=script&lang=js"

import "./HumanizedPlain.vue?vue&type=style&index=0&id=32c1c1b8&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32c1c1b8"]])

export default __exports__